// extracted by mini-css-extract-plugin
export default {"events":"Details_events__anQbS","game_title":"Details_game_title__6zruV","pagination":"Details_pagination__3Y-qi"};